import React from 'react';
import { cn } from '../utils';

export interface BadgeProps {
  variant?:
    | 'neutral'
    | 'primary'
    | 'secondary'
    | 'accent'
    | 'ghost'
    | 'info'
    | 'success'
    | 'warning'
    | 'error';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  outline?: boolean;
  children: React.ReactNode;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  variant = 'neutral',
  size = 'md',
  outline = false,
  children,
  className,
}) => {
  const badgeClasses = cn(
    'badge',
    variant === 'primary' && 'badge-primary',
    variant === 'secondary' && 'badge-secondary',
    variant === 'accent' && 'badge-accent',
    variant === 'ghost' && 'badge-ghost',
    variant === 'info' && 'badge-info',
    variant === 'success' && 'badge-success',
    variant === 'warning' && 'badge-warning',
    variant === 'error' && 'badge-error',
    size === 'xs' && 'badge-xs',
    size === 'sm' && 'badge-sm',
    size === 'lg' && 'badge-lg',
    outline && 'badge-outline',
    className
  );

  return <span className={badgeClasses}>{children}</span>;
};
